import Drawable from '../entities/Drawable.js';
import PixelText from './PixelText.js';
import { imageStore, spriteStore } from '../images.js';
import { getOSM } from '../OverworldAnimation.js';
import { globalItemDataStore } from '../OverworldAnimation.js';

export default class MartItemsMenu extends Drawable {
    constructor({ stateMachine, visible = false, position = { x: 0, y: 0 } }) {
        super();
        this.stateMachine = stateMachine;
        this.visible = visible;
        this.position = position;
        this.inventory = this.stateMachine.currentMartInventory;
        this.currentItem = 0;
        this.windowStart = 0;
        this.windowSize = 6;

        this.sprites = {
            background: spriteStore.store.pokeMartMenuBackgroundSprite,
            selectedItemArrow: spriteStore.store.selectedItemArrowSprite,
            selectedItemIcon: spriteStore.store.selectedItemIconSprite,
        };

        this.item0Text = new PixelText({
            text: 'Potion',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item1Text = new PixelText({
            text: 'Super Potion',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item2Text = new PixelText({
            text: 'Hyper Potion',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item3Text = new PixelText({
            text: 'Max Potion',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item4Text = new PixelText({
            text: 'Full Restore',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item5Text = new PixelText({
            text: 'Antidote',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item0Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item1Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item2Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item3Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item4Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item5Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.itemDescription = new PixelText({
            text: '',
            position: { x: this.position.x + 40, y: this.position.y + 126 },
            maxWidth: 200,
            color: 'white',
        });

        this.moneyLabel = new PixelText({
            text: 'MONEY',
            position: {
                x: 10,
                y: 18,
            },
            color: 'black',
        });
        this.moneyAmountText = new PixelText({
            text: `\u20BD ${getOSM().player.money}`,
            position: {
                x: 10,
                y: 30,
            },
            color: 'black',
        });
    }

    draw() {
        if (!this.visible) {
            return;
        }
        this.inventory = this.stateMachine.currentMartInventory;
        this.sprites.background.draw();
        this.sprites.selectedItemArrow.position.x = 88;
        this.sprites.selectedItemArrow.position.y = 12;

        // Set up sliding window for items
        if (this.currentItem + 2 > this.windowStart + this.windowSize) {
            // Slide window to the right
            this.windowStart = Math.min(
                this.currentItem - this.windowSize + 2,
                this.inventory.length - this.windowSize
            );
        } else if (this.currentItem < this.windowStart + 2 && this.currentItem > 0) {
            // Slide window to the left
            this.windowStart = Math.max(this.currentItem - 1, 0);
        }

        const currentWindow = this.inventory.slice(this.windowStart, this.windowStart + this.windowSize);
        const selectedItemIndexInWindow = this.currentItem - this.windowStart;

        if (currentWindow.length === 0) {
            return;
        }
        if (this.currentItem > this.inventory.length - 1) {
            this.currentItem -= 1;
        }

        currentWindow.forEach((item, index) => {
            const itemText = this[`item${index}Text`];
            const itemName = globalItemDataStore[item.itemId]?.name ?? '';
            itemText.text = itemName;
            itemText.position.y = this.position.y + 13 + 16 * index;
            itemText.draw();
            const itemAmountText = this[`item${index}Amount`];
            itemAmountText.text = `\u20BD${  `${item.cost}`.padStart(4, ' ')}`;
            itemAmountText.position.y = this.position.y + 13 + 16 * index;
            itemAmountText.draw();
        });

        this.sprites.selectedItemArrow.position.x = 88;
        this.sprites.selectedItemArrow.position.y = 12 + 16 * selectedItemIndexInWindow;
        this.sprites.selectedItemArrow.draw();
        const itemId = currentWindow[selectedItemIndexInWindow]
            ? `${currentWindow[selectedItemIndexInWindow].itemId}`
            : '';
        this.sprites.selectedItemIcon.setImage(imageStore.get(`img/items/${itemId}.png`));
        this.sprites.selectedItemIcon.draw();
        this.itemDescription.text = globalItemDataStore[itemId]?.description || '';
        this.itemDescription.draw();
        this.moneyLabel.draw();
        this.moneyAmountText.text = `\u20BD ${getOSM().player.money}`;
        this.moneyAmountText.draw();
    }
}
